import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    sidebarFooter: {
      display: 'flex',
      alignItems: 'flex-start',
      justifiContent: 'center',
      flexDirection: 'row',
      width: '100%',
      padding: '1rem 1rem 1rem 1.5rem',
      '& > img': {
        width: 36,
        height: 36,
        borderRadius: '100%',
      },
      '& section': {
        flex: 1,
      },
    },
    profilePic: {
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(2),
    },
    logout: {
      color: theme.oysterTheme.shark,
      fontWeight: 600,
      fontSize: '0.88em',
      lineHeight: '1.5em',
      padding: '0 0.5em',
      display: 'flex',
      alignItems: 'center',
    },
    logoutIcon: {
      width: '1.7em',
      height: '1.7em',
      paddingLeft: '0.5rem',
    },
    profileBtn: {
      width: '100%',
      '& .MuiButton-label': {
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      },
    },
    profileDisabledBtn: {
      width: '100%',
      justifyContent: 'flex-start',
      '& .MuiButton-label': {
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
      },
    },
    accountType: {
      color: theme.oysterTheme.charcoal,
      textAlign: 'left',
    },
    fullName: {
      color: theme.oysterTheme.charcoal,
      fontWeight: 600,
    },
    profileIcon: {
      fontSize: 14,
      marginLeft: 'auto',
    },
  }),
);

export default useStyles;
